/**
 * Kiosk Portal I18n Provider
 * Wraps shared I18nProvider with kiosk-specific configuration
 */

import type { ReactNode } from 'react'
import { I18nProvider as SharedI18nProvider } from '@ufc/core'
import i18n from '@/lib/i18n'

interface I18nProviderProps {
  children: ReactNode
}

export function I18nProvider({ children }: I18nProviderProps) {
  return <SharedI18nProvider i18n={i18n}>{children}</SharedI18nProvider>
}
